//import React from 'react';
import React from "react";
//import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './containers/Home/Home.js';
import Login from './containers/Login/Login.js';
import Menu from './containers/Menu/Menu.js';
import Cases from './containers/Cases/Cases.js';
import Mygroups from './containers/Mygroups/Mygroups.js';
import Mycases from './containers/Mycases/Mycases.js';
import Casereports from './containers/Casereports/Casereports.js';
import Registrations from './containers/Registrations/Registrations.js';
import Updatecases from "./containers/Updatecases/Updatecases.js";
import Logout from './containers/Logout/Logout.js';
import Test from './containers/Test/Test';
import Other from './containers/Other/Other';
import 'semantic-ui-css/semantic.min.css'; // Or your Semantic UI CSS file
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

const UrlNav = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact={true} path="/" element={<Login />}>
        </Route>
        <Route exact={true} path="/home" element={<Home JB='' />}>
        </Route>
        <Route exact={true} path="/registrations" element={<Registrations JB='' />}>
        </Route>
        <Route exact={true} path="/menu" element={<Menu JB='' />}>
        </Route>
        <Route exact={true} path="/cases" element={<Cases JB='' />}>
        </Route>
        <Route exact={true} path="/casereports" element={<Casereports JB='' />}>
        </Route>
        <Route exact={true} path="/mycases" element={<Mycases JB='' />}>
        </Route>
        <Route exact={true} path="/mygroups" element={<Mygroups JB='' />}>
        </Route>
        <Route exact={true} path="/updatecases"  element={<Updatecases JB=''/> }>          
        </Route>
        {/* <Route exact={true} path="/logout" element={<Logout JB='' />}>
        </Route> */}
        {/* <Route exact={true} path="/"  element={<Test />}>        
        </Route>
        <Route exact={true} path="/other"  element={<Other JB=''/> }>          
        </Route> */}
      </Routes>
    </BrowserRouter>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<UrlNav />);